import { MYPAGE_LOGIN_REQUEST } from "constants/action-types";

export const login = (userId, password) => {
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("password", password);

  return {
    type: MYPAGE_LOGIN_REQUEST,
    payload: {
      request: {
        url: "selling/my-page/authentication",
        method: "POST",
        headers: {
          'Cache-Control': 'no-cache'
        },
        data: formData
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/mypage/login.js